var Ajax = (function() {
	var __private = {
		request(url, data) {
			var method;

			if(data) method = "POST";
			else method = "GET";

			return new Promise((resolve, reject) => {
				var xhr = new XMLHttpRequest();
				xhr.open(method, url, true);
				xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

				xhr.onload = function() {
					if(this.status === 200) resolve(this);
					else {
						let error  = new Error(this.statusText);
						error.code = this.status;
						
						reject(error);
					}
				};

				xhr.onerror = function() {
					reject(new Error("Network Error"));
				};

				if(data) xhr.send(data);
				else xhr.send();
			});
		}
	};

	return {
		get(url) {
			return __private.request(url, false);
		},

		post(url, data) {
			return __private.request(url, data);
		}
	};
})();